import { ApiProperty } from "@nestjs/swagger";

export class BomItemRemovedQty{
    @ApiProperty()
    packingMaterialId:number;
    @ApiProperty()
    saleOrderId:number;
    @ApiProperty()
    itemId:number;
    @ApiProperty()
    removedQuantity:number;

    constructor(packingMaterialId:number, itemId:number, saleOrderId:number, removedQuantity:number){
        this.packingMaterialId = packingMaterialId;
        this.itemId = itemId;
        this.removedQuantity = removedQuantity;
        this.saleOrderId = saleOrderId;
    }
}